import React from 'react'
import {useTestContext} from './TestContext'
import UploadFile from '../UploadFile'
import ConfirmationModal from 'app/components/ConfirmationModal'
import FormatTimestamp from 'app/components/FormatTimestamp'
import {toAbsoluteUrl} from '_metronic/helpers'
import {Link} from 'react-router-dom'
import Button from 'app/components/Button'
import DocumentViewerModal from 'app/components/DocumentViewerModal'

const FileSection: React.FC = () => {
  const {
    selectedTest,
    handleFileUpload,
    showUploadFile,
    handleAddFileClick,
    handleViewClick,
    handleDeleteClick,
    handleDownloadClick2,
    bytesToKB,
    toggleDropdown,
    currentUser,
    isFileDeleteModalOpen,
    setIsFileDeleteModalOpen,
    selectedFile,
    isDeleting,
    handleConfirmFileDelete,
    timeframe,
    currentAuditContext,
    isDocumentViewerOpen,
    selectedDocument,
    setIsDocumentViewerOpen,
    setSelectedDocument,
  } = useTestContext()

  if (selectedTest.length === 0) {
    return <div>Loading...</div>
  }

  const test = selectedTest[0]

  const isAutomatedPlatformTest =
    (test.type === 'platform' || test.type === 'Platform') &&
    test.automated_type === true

  return (
    <div className='modal-footer'>
      <div className='mt-2 w-100'>
        {isAutomatedPlatformTest && (
          <div className='card mb-4 mt-4'>
            <div className='card-header border-1 d-flex align-items-center justify-content-between'>
              <div className='card-title'>
                <h3 className='fw-bold text-gray-900 fs-4'>Test Results</h3>
              </div>
              <div className='fs-7 badge badge-light-primary m-0'>Automated</div>
            </div>

            <div className='card-body'>
              <div className='d-flex align-items-center'>
                {test.status === 'Pass' ? (
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='24'
                    height='24'
                    viewBox='0 0 24 24'
                    fill='currentColor'
                    className='icon icon-tabler icons-tabler-filled icon-tabler-circle-check text-success'
                  >
                    <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                    <path d='M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-1.293 5.953a1 1 0 0 0 -1.32 -.083l-.094 .083l-3.293 3.292l-1.293 -1.292l-.094 -.083a1 1 0 0 0 -1.403 1.403l.083 .094l2 2l.094 .083a1 1 0 0 0 1.226 0l.094 -.083l4 -4l.083 -.094a1 1 0 0 0 -.083 -1.32z' />
                  </svg>
                ) : (
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='24'
                    height='24'
                    viewBox='0 0 24 24'
                    fill='currentColor'
                    className='icon icon-tabler icons-tabler-filled icon-tabler-xbox-x text-danger'
                  >
                    <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                    <path d='M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10m3.6 5.2a1 1 0 0 0 -1.4 .2l-2.2 2.933l-2.2 -2.933a1 1 0 1 0 -1.6 1.2l2.55 3.4l-2.55 3.4a1 1 0 1 0 1.6 1.2l2.2 -2.933l2.2 2.933a1 1 0 0 0 1.6 -1.2l-2.55 -3.4l2.55 -3.4a1 1 0 0 0 -.2 -1.4' />
                  </svg>
                )}
                <div className='d-flex flex-column ms-4'>
                  <span className='fw-bold text-gray-900 fs-6'>
                    {test.status === 'Pass' ? 'Passing' : 'Failing'}
                  </span>
                  <span className='text-gray-700 fs-7'>
                    Last evaluated: {FormatTimestamp({timestamp: test.updated_at})}
                  </span>
                </div>
              </div>
            </div>
          </div>
        )}

        {test.type === 'Document' ? (
          <>
            {!test.files || test.files.length === 0 ? (
              <>
                {currentUser?.role === 'Auditor' ? (
                  <div className='text-center py-8 mt-10'>
                    <div className='mb-4'>
                      <img
                        src='/media/buttons/EmptyState-File.svg'
                        alt='No evidence'
                        style={{width: '40px', height: '40px'}}
                      />
                    </div>
                    <div className='text-gray-900 fs-6 fw-semibold mb-2'>No Evidence Available</div>
                    <div className='text-gray-900 fs-7'>
                      No evidence has been uploaded for this test yet.
                    </div>
                  </div>
                ) : (
                  <>
                    <div className='text-gray-800 fw-semibold me-2 fs-6 mb-2 mt-4'>Evidences</div>
                    <UploadFile
                      onFileUpload={handleFileUpload}
                      fid={test.id}
                      testName={test.name}
                      selectedTimeframe={timeframe}
                      status={test.status}
                      nextUpdateDate={test.next_review_date}
                      isOpen={showUploadFile}
                    />
                  </>
                )}
              </>
            ) : (
              <>
                <div className='d-flex justify-content-end mb-2'>
                  <Button
                    onClick={handleAddFileClick}
                    btnType='primary'
                    disabled={currentUser?.role === 'Auditor' || test.status === 'Deactivated'}
                  >
                    Add File
                  </Button>
                </div>

                {showUploadFile && currentUser?.role !== 'Auditor' && (
                  <UploadFile
                    onFileUpload={handleFileUpload}
                    fid={test.id}
                    testName={test.name}
                    selectedTimeframe={timeframe}
                    status={test.status}
                    nextUpdateDate={test.next_review_date}
                    isOpen={showUploadFile}
                  />
                )}

                <div>
                  <div className='fw-bold fs-6 my-2'>Uploads</div>
                  {test.files &&
                    test.files.length > 0 &&
                    test.files.map((file, fileIndex) => (
                      <div className={`card mb-1 mt-4`} key={fileIndex}>
                        <div
                          className='card-header border-0 pt-6 mb-5'
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                          }}
                        >
                          <span
                            className='text-dark text-hover-primary'
                            style={{cursor: 'pointer'}}
                            onClick={() => handleViewClick(file)}
                          >
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                flex: 1,
                                minWidth: 0,
                              }}
                            >
                              <img
                                src='/media/icon/file2.svg'
                                alt=''
                                className='img-fluid'
                                style={{
                                  width: '50px',
                                  height: '50px',
                                  marginRight: '10px',
                                }}
                              />
                              <div
                                className='d-flex justify-content-start flex-column fw-bold fs-6'
                                style={{flexGrow: 1, minWidth: 0}}
                              >
                                <span
                                  style={{
                                    wordBreak: 'break-word',
                                    maxWidth: '400px',
                                    display: 'inline-block',
                                    verticalAlign: 'middle',
                                  }}
                                >
                                  {file.name}
                                </span>
                                <span
                                  className='fw-semibold d-block fs-7'
                                  style={{color: '#5A5A5A'}}
                                >
                                  Size: {bytesToKB(file.size)} KB
                                  {file.uploaded_at && (
                                    <>
                                      <span className='mx-2'>|</span>
                                      <span>
                                        Uploaded:
                                        <span className='ms-2'>
                                          {FormatTimestamp({timestamp: file.uploaded_at})}
                                        </span>
                                      </span>
                                    </>
                                  )}
                                </span>
                              </div>
                            </div>
                          </span>
                          <div className='dropdown'>
                            <button
                              className='btn btn-secondary border-0 p-0 '
                              type='button'
                              id='dropdownMenu2'
                              data-bs-toggle='dropdown'
                              aria-haspopup='true'
                              aria-expanded='false'
                            >
                              <img
                                src='/media/buttons/Options.svg'
                                alt='Options'
                                onClick={toggleDropdown}
                              />
                            </button>
                            <ul className='dropdown-menu' aria-labelledby='dropdownMenu2'>
                              <li>
                                <button
                                  className='dropdown-item text-hover-primary'
                                  type='button'
                                  style={{color: '#262626'}}
                                  onClick={() => handleViewClick(file)}
                                >
                                  <svg
                                    xmlns='http://www.w3.org/2000/svg'
                                    width='18'
                                    height='18'
                                    viewBox='0 0 24 24'
                                    fill='none'
                                    stroke='currentColor'
                                    strokeWidth='2'
                                    strokeLinecap='round'
                                    strokeLinejoin='round'
                                    className='icon icon-tabler icons-tabler-outline icon-tabler-eye mx-1'
                                  >
                                    <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                                    <path d='M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0' />
                                    <path d='M21 12c-2.4 4 -5.4 6 -9 6c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6' />
                                  </svg>{' '}
                                  View
                                </button>
                              </li>
                              <li>
                                <button
                                  className='dropdown-item text-hover-primary'
                                  type='button'
                                  style={{color: '#262626'}}
                                  onClick={(e) => handleDownloadClick2(file)}
                                >
                                  <svg
                                    xmlns='http://www.w3.org/2000/svg'
                                    width='18'
                                    height='18'
                                    viewBox='0 0 24 24'
                                    fill='none'
                                    stroke='currentColor'
                                    strokeWidth='2'
                                    strokeLinecap='round'
                                    strokeLinejoin='round'
                                    className='icon icon-tabler icons-tabler-outline icon-tabler-download mx-1 mb-1'
                                  >
                                    <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                                    <path d='M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2' />
                                    <path d='M7 11l5 5l5 -5' />
                                    <path d='M12 4l0 12' />
                                  </svg>{' '}
                                  Download
                                </button>
                              </li>

                              <li>
                                <button
                                  className={`dropdown-item ${
                                    currentUser?.role === 'Auditor' || currentAuditContext
                                      ? 'text-gray-500'
                                      : ''
                                  }`}
                                  type='button'
                                  style={{color: '#F15363'}}
                                  onClick={(e) => handleDeleteClick(file)}
                                  disabled={currentUser?.role === 'Auditor' || currentAuditContext}
                                >
                                  <svg
                                    xmlns='http://www.w3.org/2000/svg'
                                    width='18'
                                    height='18'
                                    viewBox='0 0 24 24'
                                    fill='none'
                                    stroke='currentColor'
                                    strokeWidth='2'
                                    strokeLinecap='round'
                                    strokeLinejoin='round'
                                    className='icon icon-tabler icons-tabler-outline icon-tabler-trash mx-1 mb-1'
                                  >
                                    <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                                    <path d='M4 7l16 0' />
                                    <path d='M10 11l0 6' />
                                    <path d='M14 11l0 6' />
                                    <path d='M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12' />
                                    <path d='M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3' />
                                  </svg>{' '}
                                  Delete
                                </button>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              </>
            )}
          </>
        ) : (
          <div>
            {!isAutomatedPlatformTest && test.fix ? (
              <div className={`card mb-5 mb-xl-8 mt-6`}>
                <div
                  className='card-header border-0 pt-6 mb-5'
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <>
                    <div className='d-flex align-items-center'>
                      <div className='d-flex justify-content-start flex-column'>
                        <span className='card-label fw-bold fs-6'>How to fix</span>
                        <div
                          className='fw-semibold fs-6 d-none d-md-block my-2 text-gray-700'
                          dangerouslySetInnerHTML={{__html: test.fix}}
                        ></div>
                      </div>
                    </div>
                  </>
                </div>
              </div>
            ) : !isAutomatedPlatformTest ? (
              <Link
                to={`/policy-library/lists?policies=${
                  test.policyId && test.policyId.length > 0 ? test.policyId[0] : ''
                }`}
                target='_blank'
                rel='noreferrer'
              >
                <div
                  className={`card mb-5 mb-xl-8 mt-6`}
                  style={{
                    transition: 'all 0.3s ease',
                    cursor: 'pointer',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.boxShadow = '0 2px 6px rgba(0, 0, 0, 0.1)'
                    e.currentTarget.style.transform = 'translateY(-2px)'
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.boxShadow = 'none'
                    e.currentTarget.style.transform = 'translateY(0)'
                  }}
                >
                  <div
                    className='card-header border-0 pt-6 mb-5'
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    <>
                      <div className='d-flex align-items-center'>
                        <div className='d-flex justify-content-start flex-column'>
                          <span className='card-label fw-bold fs-6'>How to fix</span>
                          <span className='text-gray-700 fw-semibold fs-7 d-none d-md-block my-2 w-80'>
                            Create and approve a {test.name} for your business using the templates
                            included in our{' '}
                            <a
                              href={`/policy-library/lists?policies=${
                                test.policyId && test.policyId.length > 0 ? test.policyId[0] : ''
                              }`}
                              target='_blank'
                              rel='noreferrer'
                            >
                              policy library
                            </a>
                            .
                          </span>
                        </div>
                        <div
                          onClick={() => {
                            window.open(
                              `/policy-library/lists?policies=${test.policyId[0]}`,
                              '_blank'
                            )
                          }}
                          className='mt-4'
                          style={{cursor: 'pointer'}}
                        >
                          <img src={toAbsoluteUrl(`/media/buttons/Chevron Button.svg`)} alt='' />
                        </div>
                      </div>
                    </>
                  </div>
                </div>
              </Link>
            ) : null}
          </div>
        )}
      </div>

      <ConfirmationModal
        isModalOpen={isFileDeleteModalOpen}
        hideModal={() => setIsFileDeleteModalOpen(false)}
        confirmBtnClickHandler={handleConfirmFileDelete}
        title='Delete Evidence'
        message={`Are you sure you want to delete ${selectedFile?.name}? This action cannot be undone.`}
        isLoading={isDeleting}
        type='delete'
      />
      <DocumentViewerModal
        show={isDocumentViewerOpen}
        onClose={() => {
          setIsDocumentViewerOpen(false)
          setSelectedDocument(null)
        }}
        file={selectedDocument}
      />
    </div>
  )
}

export default FileSection
